import React from 'react';
import type { LucideIcon } from 'lucide-react';

interface InputFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  type?: string;
  placeholder?: string;
  hint?: string;
  error?: string;
  required?: boolean;
  icon?: LucideIcon;
  className?: string;
}

export function InputField({
  label,
  value,
  onChange,
  type = "text",
  placeholder = "",
  hint = "",
  error = "",
  required = false,
  icon: Icon,
  className = ""
}: InputFieldProps) {
  return (
    <div className={`space-y-2 ${className}`}>
      <label className="block text-sm font-medium text-gray-900 dark:text-white">
        {label}
        {required && <span className="text-red-600 dark:text-red-400 ml-1">*</span>}
      </label>

      <div className="relative">
        {Icon && (
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
            <Icon className="h-5 w-5 text-gray-500 dark:text-white/60" />
          </div>
        )}

        <input
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className={`
            block w-full ${Icon ? 'pl-12' : 'pl-4'} pr-4 py-3 min-h-[44px]
            bg-white dark:bg-gray-800 border rounded-lg shadow-sm
            text-base sm:text-sm text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400
            focus:ring-2 focus:ring-blue-500 focus:border-transparent
            ${error ? 'border-red-400/30 focus:border-red-500 focus:ring-red-500' : 'border-gray-300 dark:border-gray-600'}
          `}
        />
      </div>

      {hint && !error && (
        <p className="text-xs text-gray-600 dark:text-white/60">{hint}</p>
      )}

      {error && (
        <p className="text-xs text-red-600 dark:text-red-400">{error}</p>
      )}
    </div>
  );
}